import { FACTORING_REQUEST_STATUS_MAP } from 'lib/consts';

import type { StatusChipType } from '../index';

type FactoringStatusKey = keyof typeof FACTORING_REQUEST_STATUS_MAP;

const FACTORING_STATUS_CHIP_MAP: Record<FactoringStatusKey, StatusChipType> = {
  CREATED: 'success',
  IN_REVIEW: 'warning',
  ACCEPTED: 'success',
  IN_TRANSFER: 'info',
  DRAFT: 'default',
  REJECTED: 'error',
  ACTIVE: 'success',
  COMPLETED: 'success',
};

const LABEL_TO_KEY = Object.fromEntries(
  Object.entries(FACTORING_REQUEST_STATUS_MAP).map(([k, v]) => [v, k]),
) as Record<string, FactoringStatusKey>;

export const getFactoringStatusChipType = (
  statusOrLabel: string,
): StatusChipType => {
  const key =
    statusOrLabel in FACTORING_REQUEST_STATUS_MAP
      ? (statusOrLabel as FactoringStatusKey)
      : LABEL_TO_KEY[statusOrLabel];
  return (key && FACTORING_STATUS_CHIP_MAP[key]) ?? 'default';
};

export const getFactoringStatusLabel = (statusOrKey: string): string => {
  if (statusOrKey in FACTORING_REQUEST_STATUS_MAP) {
    return FACTORING_REQUEST_STATUS_MAP[statusOrKey as FactoringStatusKey];
  }
  return statusOrKey;
};
